export default __webpack_public_path__ + "images/IW.de87fb3.png";